import { withStyles } from '@material-ui/core/styles';
const styles = (theme) => ({
  container: {
    backgroundColor: theme.gridHeaderBGColor,
    color: theme.gridHeaderFontColor,
    padding: 8,
    boxShadow: "0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)" /* to match with old theme */
  },
});

const CustomLoadingOverlay =  ({ classes, loadingMessage }) => {
  return (
    <span className={classes.container} key="loading">
      {loadingMessage}
    </span>
  );
};

export default withStyles(styles)(CustomLoadingOverlay);